import React from 'react';

// [Use] <Skeleton className="w-full h-32 rounded-xl" />
export default function Skeleton({ className, ...props }) {
    return (
        <div
            className={`animate-shimmer bg-gray-200 ${className}`}
            {...props}
        />
    );
}
